import { render, staticRenderFns } from "./OfferMetrics.vue?vue&type=template&id=72e2bf6d&scoped=true&"
import script from "./OfferMetrics.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OfferMetrics.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OfferMetrics.vue?vue&type=style&index=0&id=72e2bf6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2bf6d",
  null
  
)

export default component.exports